import { UiStatus } from './types'

export const uiStatusColor = (status: UiStatus): string => {
  switch (status) {
    case 'COMPLETED':
      return 'success'
    case 'DECLINED':
      return 'danger'
    default:
      return 'primary'
  }
}
